// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/self-service-item/self-service-item.component.scss
// module id = 495
// module chunks = 0